import Modal from '@/shared/components/UI/Modal';
import Button from '@/shared/components/UI/Button';

interface PrivacyPolicyModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const PrivacyPolicyModal: React.FC<PrivacyPolicyModalProps> = ({
  isOpen,
  onClose,
}) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} size="sm">
      <div className="text-left">
        <h2 className="mb-4 text-lg font-bold text-[#1D1D1D]">
          개인정보 처리방침
        </h2>

        <div className="max-h-[50vh] overflow-y-auto pr-2">
          <div className="text-xs text-[#1D1D1D]">
            <p>
              주식회사 브이에이트코프는 이용자의 개인정보를 보호하고 이와 관련한
              고충을 신속하고 원활하게 처리할 수 있도록 다음과 같이 개인정보
              처리방침을 수립·공개하며, 본 개인정보 처리방침을 홈페이지 첫
              화면에 공개함으로써 이용자들이 언제나 용이하게 보실 수 있도록
              조치하고 있습니다. 개인정보 처리방침은 정부의 법률 및 지침
              변경이나 회사의 내부 방침 변경 등으로 인하여 수시로 변경될 수
              있고, 이에 따른 개인정보 처리방침의 지속적인 개선을 위하여 필요한
              절차를 정하고 있습니다. 이용자들께서는 사이트 방문 시 수시로
              확인하시기 바랍니다.
            </p>
            <p>
              주식회사 브이에이트코프는의 개인정보 처리방침은 다음과 같은 내용을
              담고 있습니다.
            </p>
            <ul>
              <li>개인정보 수집에 대한 동의</li>
              <li>수집하는 개인정보 항목 및 수집방법</li>
              <li>개인정보의 수집 및 이용목적</li>
              <li>수집하는 개인정보의 보유 및 이용기간</li>
              <li>개인정보의 파기 절차 및 방법</li>
              <li>수집한 개인정보의 공유 및 제공</li>
              <li>
                이용자 자신의 개인정보 관리(열람,정정,삭제 등)에 관한 사항
              </li>
              <li>쿠키(Cookie)의 운용 및 거부</li>
              <li>개인정보의 위탁처리</li>
              <li>개인정보보호를 위한 기술적/관리적 대책</li>
              <li>개인정보 관련 의견수렴 및 불만처리에 관한 사항</li>
              <li>개인정보 보호책임자 및 담당자의 소속-성명 및 연락처</li>
              <li>이용자 및 법정대리인의 권리와 그 행사방법</li>
              <li>권익침해 구제방법</li>
              <li>고지의 의무</li>
              <li>개인정보의 국외 이전에 관한 사항</li>
            </ul>

            <h3>**1. 개인정보 수집에 대한 동의**</h3>
            <p>
              주식회사 브이에이트코프는 이용자들이 회사의 개인정보수집이용 동의
              또는 이용약관의 내용에 대하여 「동의」버튼 또는 「취소」버튼을
              클릭할 수 있는 절차를 마련하여, 「동의」버튼을 클릭하면 개인정보
              수집에 대해 동의한 것으로 봅니다.
            </p>

            <h3>**2. 수집하는 개인정보의 항목 및 수집방법**</h3>
            <h4>1. 수집 항목</h4>
            <p>
              주식회사 브이에이트코프는 이용자들이 회원서비스를 이용하기 위해
              회원으로 가입하실 때 서비스 제공을 위한 필수/선택적인 정보들을
              온라인상에서 입력 받고 있습니다.
            </p>
            <ul>
              <li>
                회원 가입 시에 받는 필수적인 정보 : 이름, 이메일 주소,
                휴대폰번호
              </li>
              <li>
                회원제 서비스 이용에 따른 본인 확인 절차에 이용 시 수집 정보 :
                이름, 이메일 주소, 휴대폰번호 (twilio sms인증 및 메일
                인증서비스를 통함.)
              </li>
              <li>
                자동 로그인 이용을 위한 본인 확인 정보 수집 : 아이디 , 암호화된
                비밀번호
              </li>
              <li>
                서비스 및 부가 서비스 이용에 대한 요금 결제 시 수집하는 정보 :
                은행계좌정보, 신용카드정보
              </li>
              <li>
                기타 양질의 서비스 제공을 위하여 선택적으로 수집하는 정보 :
                전화번호, 서비스 이용 과정에서 서비스 제공을 위해 자동으로
                수집하는 정보가 있을 수 있으며, 이와 같이 수집된 정보는
                개인정보와의 연계 등에 따라 개인정보에 해당할 수 있고,
                개인정보에 해당하지 않을 수도 있습니다.
              </li>
              <li>
                통계 수집을 위한 회원가입, 방문자, 주문자, 게시글 작성 시 생성
                정보 : IP Address , 브라우저 정보, OS정보, 서비스 이용 기록,
                유입경로, 나이, 배송지역, 성별, 아이디 (이메일)
              </li>
              <li>
                불량회원의 부정 이용 방지와 비인가 사용 방지를 위해 수집하는
                정보 : IP Address
              </li>
              <li>
                회원 CS처리 및 회원 관리를 위한 수정 이전 정보 : 이름, 이메일,
                전화번호, 주소 등
              </li>
              <li>
                그 외 서비스 제공을 위해 자동으로 수집하고 있는 정보 : 쿠키
              </li>
            </ul>
            <h4>2. 수집 방법</h4>
            <p>
              주식회사 브이에이트코프는 다음과 같은 방법으로 개인정보를
              수집합니다.
            </p>
            <ul>
              <li>
                홈페이지, 모바일기기, 서면양식, 팩스, 전화, 상담 게시판, 이메일,
                이벤트 응모, 배송요청
              </li>
              <li>고객 동의 및 고객 입력을 통한 정보 수집</li>
              <li>협력회사로부터의 제공</li>
              <li>생성정보 수집 툴을 통한 수집</li>
            </ul>
            <p>
              기타쇼핑몰 내에서의 설문조사나 이벤트 행사 시 통계분석이나
              경품제공 등을 위해 선별적으로 개인정보 입력을 요청할 수 있습니다.
              그러나, 이용자의 기본적 인권 침해의 우려가 있는 민감한
              개인정보(인종 및 민족, 사상 및 신조, 출신지 및 본적지, 정치적 성향
              및 범죄기록, 건강상태 및 성생활 등)는 수집하지 않으며 부득이하게
              수집해야 할 경우 이용자들의 사전동의를 반드시 구할 것입니다.
            </p>

            <h3>**3. 개인정보의 수집 및 이용 목적**</h3>
            <p>
              주식회사 브이에이트코프는는 이용자의 사전 동의 없이는 이용자의
              개인 정보를 수집하지 않으며, 수집된 정보는 아래와 같이 이용하고
              있습니다.
            </p>
            <h4>1. 신규 서비스의 개발</h4>
            <p>
              이용자들이 제공한 개인정보를 바탕으로 보다 더 유용한 서비스를
              개발할 수 있습니다. 회사는 신규 서비스 개발이나 컨텐츠의 확충 시에
              기존 이용자들이 회사에 제공한 개인정보를 바탕으로 개발해야 할
              서비스의 우선 순위를 보다 더 효율적으로 정하고, 회사는 이용자들이
              필요로 할 컨텐츠를 합리적으로 선택하여 제공할 수 있습니다.
            </p>
            <h4>2. 회원관리</h4>
            <p>
              회원제 서비스 이용에 따른 본인확인, 개인 식별, 불량회원의 부정
              이용 방지와 비인가 사용 방지, 가입 의사 확인, 연령확인, 주문 및
              결제처리, 배송처리, 만14세 미만 아동 개인정보 수집 시 법정 대리인
              동의여부 확인, 불만처리 등 민원처리, 고지사항 전달
            </p>
            <h4>3. 마케팅 및 광고에 활용</h4>
            <p>
              신규 서비스 개발과 이벤트 행사에 따른 정보 전달 및 맞춤 서비스
              제공, 인구통계학적 특성에 따른 서비스 제공 및 광고 게재, 접속 빈도
              파악 또는 회원의 서비스 이용에 대한 통계
            </p>

            <h3>**4. 수집하는 개인정보의 보유 및 이용기간**</h3>
            <p>
              주식회사 브이에이트코프는 이용자의 개인정보를 원칙적으로
              개인정보의 수집 및 이용목적이 달성되면 지체 없이 파기합니다. 단,
              다음의 정보에 대해서는 아래의 이유로 명시한 기간 동안 보존합니다.
            </p>
            <h4>1. 관련법령에 의한 정보보유 사유</h4>
            <ul>
              <li>
                계약 또는 청약철회 등에 관한 기록 : 5년 (전자상거래등에서의
                소비자보호에 관한 법률)
              </li>
              <li>
                대금결제 및 재화 등의 공급에 관한 기록 : 5년 (전자상거래등에서의
                소비자보호에 관한 법률)
              </li>
              <li>
                소비자의 불만 또는 분쟁처리에 관한 기록 : 3년
                (전자상거래등에서의 소비자보호에 관한 법률)
              </li>
              <li>방문(로그)에 관한 기록 : 3개월(통신비밀보호법)</li>
            </ul>

            <h3>**5. 개인정보의 파기 절차 및 방법**</h3>
            <p>
              주식회사 브이에이트코프는 귀중한 회원의 개인정보를 안전하게
              처리하며, 유출의 방지를 위하여 다음과 같은 방법을 통하여
              개인정보를 파기합니다.
            </p>
            <h4>1. 파기절차</h4>
            <p>
              이용자가 서비스 이용 등을 위해 입력하신 정보는 목적이 달성된 후
              별도의 DB로 옮겨져(종이의 경우 별도의 서류함) 내부 방침 및 기타
              관련 법령에 의한 정보보호 사유에 따라(보유 및 이용기간 참조) 일정
              기간 저장된 후 파기됩니다. 별도 DB로 옮겨진 개인정보는 법률에 의한
              경우가 아니고서는 보유되어지는 이외의 다른 목적으로 이용되지
              않습니다.
            </p>
            <h4>2. 파기방법</h4>
            <ul>
              <li>종이에 출력된 개인정보 : 분쇄기로 분쇄하거나 소각</li>
              <li>
                전자적 파일 형태로 저장된 개인정보 : 기록을 재생할 수 없는
                기술적 방법을 사용하여 삭제
              </li>
            </ul>

            <h3>**6. 수집한 개인정보의 공유 및 제공**</h3>
            <p>
              주식회사 브이에이트코프는 이용자들의 개인정보를 동의받은 범위
              내에서 사용하며, 이용자의 사전 동의 없이는 동 범위를 초과하여
              이용하거나 원칙적으로 이용자의 개인정보를 외부에 공유 및 제공하지
              않습니다. 다만, 아래의 경우에는 예외로 합니다.
            </p>
            <ul>
              <li>이용자들이 사전에 공유 및 제공에 동의한 경우</li>
              <li>서비스 제공에 따른 요금정산을 위하여 필요한 경우</li>
              <li>
                법령의 규정에 의거하거나, 수사 목적으로 법령에 정해진 절차와
                방법에 따라 수사기관의 요구가 있는 경우
              </li>
            </ul>

            <h3>
              **7. 이용자 자신의 개인정보 관리(열람,정정,삭제 등)에 관한 사항**
            </h3>
            <p>
              회원님이 원하실 경우 언제라도 당사에서 개인정보를 열람하실 수
              있으며 보관된 필수 정보를수정하실 수 있습니다. 또한 회원 가입 시
              요구된 필수 정보 외의 추가 정보는 언제나 열람,수정, 삭제할 수
              있습니다. 회원님의 개인정보 변경 및 삭제와 회원탈퇴는 당사의
              마이페이지에서로그인(Login) 후 이용하실 수 있습니다.
            </p>

            <h3>**8. 쿠키(Cookie)의 운용 및 거부**</h3>
            <h4>1. 쿠키의 사용 목적</h4>
            <p>
              회사는 개인 맞춤 서비스를 제공하기 위해서 이용자에 대한 정보를
              저장하고 수시로 불러오는 -쿠키(cookie)- 를 사용합니다. 쿠키는
              웹사이트 서버가 이용자의 브라우저에게 전송하는 소량의 정보로서
              이용자 컴퓨터의 하드디스크에 저장됩니다.
            </p>
            <p>
              회사는 쿠키의 사용을 통해서만 가능한 특정된 맞춤형 서비스를 제공할
              수 있습니다.
            </p>
            <p>
              회사는 회원을 식별하고 회원의 로그인 상태를 유지하기 위해 쿠키를
              사용할 수 있습니다.
            </p>
            <h4>2. 쿠키의 설치/운용 및 거부</h4>
            <p>
              이용자는 쿠키 설치에 대한 선택권을 가지고 있습니다. 따라서
              이용자는 웹브라우저에서 옵션을 조정함으로써 모든 쿠키를
              허용/거부하거나, 쿠키가 저장될 때마다 확인을 거치도록 할 수
              있습니다.
            </p>
            <ul>
              <li>
                쿠키 설치 허용 여부를 지정하는 방법(Internet Explorer의 경우)은
                다음과 같습니다.
              </li>
              <li>
                Internet Explorer 웹 브라우저: [도구] {'>'} [인터넷 옵션] {'>'}{' '}
                [개인정보] 탭 {'>'} [설정] 변경
              </li>
              <li>
                Chrome 웹 브라우저: 우측 상단 메뉴 [설정] {'>'} [고급] {'>'}{' '}
                [콘텐츠 설정] {'>'} [쿠키] 설정
              </li>
            </ul>
            <p>
              쿠키의 저장을 거부할 경우에는 개인 맞춤서비스 등 회사가 제공하는
              일부 서비스는 이용이 어려울 수 있습니다.
            </p>

            <h3>**9. 개인정보의 위탁처리**</h3>
            <p>
              주식회사 브이에이트코프는 개인정보의 처리와 관련하여 아래와 같이
              업무를 위탁하고 있으며, 관계 법령에 따라 위탁계약 시 개인정보가
              안전하게 관리될 수 있도록 필요한 사항을 규정하고 있습니다. 또한
              위탁하는 정보는 당해 목적을 달성하기 위하여 필요한 최소한의 정보에
              국한됩니다.
            </p>
            <ul>
              <li>위탁 대상자 : [CJ대한통운, DHL]</li>
              <li>위탁업무 내용 : [주문 상품 배송 위탁]</li>
              <li>위탁 대상자 : [엑심베이]</li>
              <li>위탁업무 내용 : [상품 대금 결제]</li>
            </ul>

            <h3>**10. 개인정보보호를 위한 기술적/관리적 대책**</h3>
            <p>
              주식회사 브이에이트코프는 이용자의 개인정보를 처리함에 있어
              개인정보가 분실, 도난, 유출, 변조, 또는 훼손되지 않도록 안전성
              확보를 위하여 다음과 같은 관리적, 기술적, 물리적 대책을 강구하고
              있습니다.
            </p>
            <ul>
              <li>
                관리적 조치 : 내부관리계획 수립. 시행, 정기적 직원 교육 등
              </li>
              <li>
                기술적 조치 : 개인정보처리시스템 등의 접근권한 관리,
                접근통제시스템 설치, 고유식별정보 등의 암호화, 보안프로그램 설치
              </li>
              <li>물리적 조치 : 전산실, 자료보관실 등의 접근통제</li>
            </ul>
            <p>
              주식회사 브이에이트코프는이용자 개인의 실수나 기본적인 인터넷의
              위험성 때문에 일어나는 일들에 대해 책임을 지지 않습니다. 이용자
              개개인이 본인의 개인정보를 보호하기 위해서 자신의 아이디(ID) 와
              비밀번호를 적절하게 관리하고 이에 대한 책임을 져야 합니다.
            </p>

            <h3>**11. 개인정보 관련 의견수렴 및 불만처리에 관한 사항**</h3>
            <p>
              주식회사 브이에이트코프는 개인정보보호와 관련하여 이용자
              여러분들의 의견을 수렴하고 있으며 불만을 처리하기 위하여 모든
              절차와 방법을 마련하고 있습니다. 이용자들은 하단에 명시한 -13.
              개인정보 관리책임자 및 담당자의 소속-성명 및 연락처- 항을 참고하여
              전화나 메일을 통하여 불만사항을 신고할 수 있고, 주식회사
              브이에이트코프는 이용자들의 신고사항에 대하여 신속하고도 충분한
              답변을 해 드릴 것입니다.
            </p>

            <h3>**12. 개인정보 보호책임자 및 담당자의 소속-성명 및 연락처**</h3>
            <p>
              주식회사 브이에이트코프는 개인정보 처리에 관한 업무를 총괄해서
              책임지고, 개인정보 처리와 관련한 이용자의 불만처리 및 피해구제
              등을 위하여 아래와 같이 개인정보 보호책임자를 지정하고 있습니다.
            </p>
            <p>이름 : 김정율</p>
            <p>소속 / 직위 : 대표자</p>
            <p>
              E-M A I L :{' '}
              <a href="mailto:help@kmonstar.com">help@kmonstar.com</a>
            </p>
            <p>전 화 번 호 : 010-6791-7418</p>

            <h3>**13. 이용자 및 법정대리인의 권리와 그 행사방법**</h3>
            <p>
              1. 이용자 및 법정 대리인은 언제든지 등록되어 있는 자신 혹은 당해
              만 14세 미만 아동의 개인정보를 조회하거나 수정할 수 있으며
              가입해지(동의철회)를 요청할 수도 있습니다.
            </p>
            <p>
              2. 이용자 혹은 만 14세 미만 아동의 개인정보 조회, 수정을 위해서는
              로그인 후 MyPage에서 ‘개인정보변경’(또는 ‘회원정보수정’ 등)을,
              가입해지(동의철회)를 위해서는 -회원탈퇴- 를 클릭하여 본인 확인
              절차를 거치신 후 직접 열람, 정정 또는 탈퇴가 가능합니다. 혹은
              개인정보 보호책임자에게 서면, 전화 또는 이메일로 연락하시면 지체
              없이 조치하겠습니다.
            </p>
            <h3>**13. 이용자 및 법정대리인의 권리와 그 행사방법**</h3>
            <p>
              1. 이용자 및 법정 대리인은 언제든지 등록되어 있는 자신 혹은 당해
              만 14세 미만 아동의 개인정보를 조회하거나 수정할 수 있으며
              가입해지(동의철회)를 요청할 수도 있습니다.
            </p>
            <p>
              2. 이용자 혹은 만 14세 미만 아동의 개인정보 조회, 수정을 위해서는
              로그인 후 MyPage에서 ‘개인정보변경’(또는 ‘회원정보수정’ 등)을,
              가입해지(동의철회)를 위해서는 -회원탈퇴- 를 클릭하여 본인 확인
              절차를 거치신 후 직접 열람, 정정 또는 탈퇴가 가능합니다. 혹은
              개인정보 보호책임자에게 서면, 전화 또는 이메일로 연락하시면 지체
              없이 조치하겠습니다.
            </p>
            <p>
              3. 이용자가 개인정보의 오류에 대한 정정을 요청하신 경우에는 정정을
              완료하기 전까지 당해 개인정보를 이용 또는 제공하지 않습니다. 또한
              잘못된 개인정보를 제3자에게 이미 제공한 경우에는 정정 처리결과를
              제3자에게 지체 없이 통지하여 정정이 이루어지도록 하겠습니다.
            </p>
            <p>
              4. 주식회사 브이에이트코프는 이용자 혹은 법정 대리인의 요청에 의해
              해지 또는 삭제된 개인정보는 -수집하는 개인정보의 보유 및 이용기간-
              에 명시된 바에 따라 처리하고 그 외의 용도로 열람 또는 이용할 수
              없도록 처리하고 있습니다.
            </p>

            <h3>**14. 권익침해 구제방법**</h3>
            <p>
              이용자는 아래의 기관에 대해 개인정보 침해에 대한 피해구제, 상담
              등을 문의하실 수 있습니다. 아래의 기관은 회사와는 별개의
              기관으로서, 회사의 자체적인 개인정보 불만처리, 피해구제 결과에
              만족하지 못하시거나 보다 자세한 도움이 필요하시면 문의하여 주시기
              바랍니다.
            </p>
            <ul>
              <li>
                ▶ 개인정보 침해신고센터 (한국인터넷진흥원 운영)
                <ul>
                  <li>소관업무 : 개인정보 침해사실 신고, 상담 신청</li>
                  <li>
                    홈페이지 :{' '}
                    <a href="http://privacy.kisa.or.kr">privacy.kisa.or.kr</a>
                  </li>
                  <li>
                    전화 : (국번없이) <a href="tel:118">118</a>
                  </li>
                  <li>
                    주소 : (58324) 전남 나주시 진흥길 9(빛가람동 301-2) 3층
                    개인정보침해신고센터
                  </li>
                </ul>
              </li>
              <li>
                ▶ 개인정보 분쟁조정위원회
                <ul>
                  <li>
                    소관업무 : 개인정보 분쟁조정신청, 집단분쟁조정 (민사적 해결)
                  </li>
                  <li>
                    홈페이지 :{' '}
                    <a href="http://www.kopico.go.kr">www.kopico.go.kr</a>
                  </li>
                  <li>
                    전화 : (국번없이) <a href="tel:1833-6972">1833-6972</a>
                  </li>
                  <li>
                    주소 : (03171) 서울특별시 종로구 세종대로 209 정부서울청사
                    4층
                  </li>
                </ul>
              </li>
              <li>
                ▶ 대검찰청 사이버수사과 :{' '}
                <a href="http://www.spo.go.kr">www.spo.go.kr</a>
              </li>
              <li>
                ▶ 경찰청 사이버안전국 :{' '}
                <a href="http://cyberbureau.police.go.kr">
                  cyberbureau.police.go.kr
                </a>
              </li>
            </ul>

            <h3>**15. 고지의 의무**</h3>
            <p>
              현 개인정보처리방침의 내용은 정부의 정책 또는 보안기술의 변경에
              따라 내용의 추가 삭제 및 수정이 있을 시에는 홈페이지의 -공지사항-
              을 통해 고지할 것입니다.
            </p>
            <p>개인정보처리방침 시행일자: 2025-01-01</p>
            <p>개인정보처리방침 변경일자: 2025-01-01</p>
          </div>
        </div>

        <div className="mt-6">
          <Button
            type="button"
            variant="primary"
            size="xs"
            onClick={onClose}
            fullWidth
          >
            Verify
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default PrivacyPolicyModal;
